export const statusDialog = {
  namespaced: true,
  state: {
    dialog: false,
    type: null,
    message: null,
  },
  getters: {},
  actions: {},
  mutations: {
    showSuccessDialog(state, message) {
      state.dialog = true;
      state.message = message || "Success";
      state.type = "success";
    },
    showErrorDialog(state, message) {
      state.dialog = true;
      state.message = message || "Error";
      state.type = "error";
    },
    showWarningDialog(state, message) {
      state.dialog = true;
      state.message = message || "Warning";
      state.type = "warning";
    },
    closeDialog(state) {
      state.dialog = false;
      state.message = null;
      state.type = null;
    },
    resetDialog(state) {
      state.dialog = false;
      state.message = null;
      state.type = null;
    },
  },
};
